import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Picker, List, WhiteSpace } from 'antd-mobile/lib';
import Util from '../../util.js';
import NavigatorMain from '../NavigatorMain';

import { hashHistory } from 'react-router';
import {superFundCodeFee } from '../../common';

// import { setStorage, getStorage, urlAllBase, isLoginAndRealName } from '../../CommonVar';


/*费率介绍*/
export default class SuperRate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingFlag:true,
    }
  }
  componentWillMount() {
  }
  handleCallback(){

  }
  componentDidMount(){
    let { dispatch } = this.props;
  }
  componentWillUnmount() {
    
  }
  goBack(){
    hashHistory.goBack();
  }
  render(){
    let isAllMonetary = this.props.location.state && this.props.location.state.isAllMonetary
    let superFundCode = this.props.location.state && this.props.location.state.superFundCode
    console.log(superFundCode);
    return(
      <div className="container">
        <NavigatorMain>
          <div className="header black">
            <div style={{ WebkitFlex:1 }}><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
            <div style={{ WebkitFlex:2, textAlign:'center', fontSize:"0.3rem" }}> 费率详情 </div>
            <div style={{ WebkitFlex:1, textAlign:'right', fontSize:"0.28rem", paddingRight:'13px' }}></div>    
          </div>
        </NavigatorMain>

        <div className="content">
      		{/* <div className="comonTitle" style={{ backgroundColor: isAllMonetary ? "#FFF" : null }}>
  	        	<div><span>账户投资顾问服务费</span></div>
  	        	<div><span className="" style={{color:'#000'}}>{ isAllMonetary ? '0.2%/年' : "" }</span></div>
  	     </div>
         {
          isAllMonetary ? null :
          <div style={{backgroundColor:"#FFF"}}>
            <div style={{ display: "-webkit-flex", height:36  }}>
                <div style={{ WebkitFlex:6, display: "-webkit-flex", WebkitJustifyContent:"center", WebkitAlignItems: "center", fontSize:14 }}><span>账户资产净值</span></div>
                <div style={{ WebkitFlex:4, display: "-webkit-flex", WebkitJustifyContent:"center", WebkitAlignItems: "center", fontSize:14 }}><span>投资顾问服务费率（年）</span></div>
            </div>

            <div style={{ display: "-webkit-flex", height:36, backgroundColor:"rgb(249,249,250)" }}  >
              <div style={{ WebkitFlex:6, display: "-webkit-flex", WebkitJustifyContent:"center", WebkitAlignItems: "center", fontSize:13 }}><span> 20万以下 </span></div>
              <div style={{ WebkitFlex:4, display: "-webkit-flex", WebkitJustifyContent:"center", WebkitAlignItems: "center", fontSize:13 }}><span> 1% </span></div>
            </div>

            <div style={{ display: "-webkit-flex", height:36 }}  >
              <div style={{ WebkitFlex:6, display: "-webkit-flex", WebkitJustifyContent:"center", WebkitAlignItems: "center", fontSize:13 }}><span> 20万-100万 </span></div>
              <div style={{ WebkitFlex:4, display: "-webkit-flex", WebkitJustifyContent:"center", WebkitAlignItems: "center", fontSize:13 }}><span>  0.8% </span></div>
            </div>

            <div style={{ display: "-webkit-flex", height:36, backgroundColor:"rgb(249,249,250)" }} >
              <div style={{ WebkitFlex:6, display: "-webkit-flex", WebkitJustifyContent:"center", WebkitAlignItems: "center", fontSize:13 }}><span>100万-500万 </span></div>
              <div style={{ WebkitFlex:4, display: "-webkit-flex", WebkitJustifyContent:"center", WebkitAlignItems: "center", fontSize:13 }}><span> 0.6% </span></div>
            </div>

            <div style={{ display: "-webkit-flex", height:36 }}  >
              <div style={{ WebkitFlex:6, display: "-webkit-flex", WebkitJustifyContent:"center", WebkitAlignItems: "center", fontSize:13 }}><span> 500万以上 </span></div>
              <div style={{ WebkitFlex:4, display: "-webkit-flex", WebkitJustifyContent:"center", WebkitAlignItems: "center", fontSize:13 }}><span>  0.4% </span></div>
            </div>
          </div>
         }
          
          <div style={{marginTop:'0.4rem',minheight:'0.9rem',height:"auto",padding:'0 13px'}}>
             <p style={{color:"#5b6370",fontSize:14 }}>温馨提示：</p>
             <p style={{color:"#5b6370",fontSize:12,lineHeight:"16px" }} >
              账户管理费每日从账户中计提，按每月扣除。当账户出现赎回时，将扣除之前发生的管理费。
              </p>
          </div> */}
          <p style={{color:"#5b6370",fontSize:16,lineHeight:"22px" }}>1、申购费与赎回费：</p>
          <p style={{color:"#5b6370",fontSize:16,lineHeight:"22px" }}>本组合不重复收取申购费用、赎回费用。 成分基金申购费用0至1折，成分基金赎回费用按照基金招募说明书收取。</p>
          <p style={{color:"#5b6370",fontSize:16,lineHeight:"22px" }}>2、投资顾问服务费：</p>
          <p style={{color:"#5b6370",fontSize:16,lineHeight:"22px" }}>{`本组合以客户账户资产净值${this.props.location.state && this.props.location.state.manageFeeRate?this.props.location.state.manageFeeRate +'%':superFundCodeFee(superFundCode)}（年化）计提投资顾问服务费。每日计提，月度结算。`}</p>
          <div style={{paddingTop: "10px"}}>
            <p style={{color:"#5b6370",fontSize:16,lineHeight:"22px" }}>具体以网站公告、移动端投顾组合产品页面标识信息为准。</p>
          </div>
        </div>
      </div>
    );
  }
}


function getFx(fundtype){
  let touzFx = "";
  if(fundtype == "股票型" || fundtype == "指数型"){
    touzFx = "高"
  }else if(fundtype == "混合型" || fundtype == "债券型"){
    touzFx = "中"
  }else if(fundtype == "货币型" || fundtype == "理财型"){
    touzFx = "低"
  }
  return  touzFx;
}

/*根据对象参数按从小到大排序*/   
let compare = function (prop) {
    return function (obj1, obj2) {
        var val1 = obj1[prop];
        var val2 = obj2[prop];
        if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
            val1 = Number(val1);
            val2 = Number(val2);
        }
        if (val1 < val2) {
            return -1;
        } else if (val1 > val2) {
            return 1;
        } else {
            return 0;
        }            
    } 
}




// WEBPACK FOOTER //
// ./src/components/fundDetail/SuperRate.js